window.addEventListener('load', enableToggleInfo);

function enableToggleInfo() {
  const toggleInfoDivs = document.querySelectorAll('.toggle-info');

  for (let i = 0; i < toggleInfoDivs.length; i++) {
    const toggleInfoDiv = toggleInfoDivs[i];
    const lineItemId = toggleInfoDiv.getAttribute('data-line-item-id');
    toggleInfoDiv.addEventListener('click', toggleInfo(lineItemId));
  }
}

function toggleInfo(lineItemId) {
  return () => {
    const toggleInfoDivs = document.querySelectorAll(
      `.toggle-info[data-line-item-id="${lineItemId}"]`
    );
    const infoDivs = document.querySelectorAll(
      `.line-item-info[data-line-item-id="${lineItemId}"]`
    );

    // if expand === true, then we want to expand instances this particular item
    const expand = !infoDivs[0].classList.contains('open');

    toggleInfoDivs.forEach(toggleInfoDiv => {
      toggleInfoDiv.innerHTML = expand ? '- less info' : '+ more info';
    });

    infoDivs.forEach(infoDiv => {
      expand ? infoDiv.classList.add('open') : infoDiv.classList.remove('open');
    });
  };
}
